<template>
	<div
		@click="click"
		class="outer"
		:style="{ height: height, 'line-height': `calc(${height} - 4px)` }"
	>
		<div class="inner no-select">
			<slot />
		</div>
	</div>
</template>

<style scoped>
.outer {
	overflow: hidden;
	height: 30px;
	line-height: 30px;
	white-space: normal !important;
	display: block !important;
}
.outer::before {
	content: "";
	display: inline-block;
}
.inner {
	display: inline-block;
	white-space: nowrap;
	font-weight: 600;
}
</style>

<script>
export default {
	name: "HideOverflow",
	props: {
		height: true,
		click: {
			type: Function,
			default: () => {}
		}
	},

	data() {
		return {};
	},
	mounted() {},
	watch: {},
	methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/HideOverflow.vue